/* eslint-disable no-param-reassign */
import EditsGraph from 'components/EditsGraph';
import React, { useEffect } from 'react';
import { graphsInitStatus } from './reducer';

import './style.css';

function Graphs({ state, containerRef, mainRef }: any): JSX.Element {
  const currentGraphState = graphsInitStatus;

  const handleResize = () => {
    if (mainRef.current && containerRef.current) {
      const { width, height } = mainRef.current.getBoundingClientRect();
      containerRef.current.style.height = `${height}px`;
      containerRef.current.style.width = `${width}px`;
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  /**
   *
   * @param graphName
   * @returns xAxis lables, yValue for Bar Chart, yValue for Line Chart
   */
  function getGraphLableAndValues(
    graphName: string,
  ): [string[], number[], number[]] {
    const x = Object.keys(state[graphName]?.records || {});
    const yData: {
      numOfEdits: number;
      totalNotes: number;
    }[] = Object.values(state[graphName]?.records || {}).map((obj: any) => {
      return {
        numOfEdits: obj.num_of_edits,
        totalNotes: obj.total_notes,
      };
    });

    const yBar = yData.map((doc) => {
      return doc.totalNotes;
    });

    const yLine = yData.map((doc) => {
      const value = (doc.numOfEdits / doc.totalNotes) * 100;
      // converting to single digit value
      return Math.round(value * 10) / 10;
    });

    return [x, yBar, yLine];
  }

  // Show Graph, either in window or fullScreen based on expanded state via reducer.
  // default is expanded mode, i.e, full window mode.
  function showGraph() {
    function setDimensionsOfGraph(
      graphName: string,
      height: number,
      showXLabels: boolean,
    ) {
      const [xLabels, yValuesBar, yValuesLine] =
        getGraphLableAndValues(graphName);
      let title = graphName[0].toUpperCase() + graphName.slice(1);
      const name = title;
      title += ' - Edit Distribution';
      return (
        <div
          key={graphName}
          ref={containerRef}
          className="graph"
          // style={{ width: '83vw', position: 'relative', height: '80vh' }}
        >
          <EditsGraph
            title={title}
            showXLabels={showXLabels}
            nameXAxis={name}
            xLables={xLabels}
            yValuesBar={yValuesBar}
            yValuesLine={yValuesLine}
            height={height}
          />
        </div>
      );
    }
    return (
      <div
        className="all-graphs"
        style={{ display: 'block', margin: '10px 0 0 0px' }}
      >
        {setDimensionsOfGraph(currentGraphState.expandedGraphName, 560, true)}
      </div>
    );
  }
  return showGraph();
}

export default Graphs;
